<div
    class="parking-operator-card bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-200 p-4 sm:p-6">
    <!-- Header Section -->
    <div class="flex items-start justify-between mb-4">
        <!-- Operator Info -->
        <div class="flex items-center space-x-3">
            <!-- Avatar -->
            <div class="flex-shrink-0">
                <div class="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <span class="text-white font-semibold text-sm sm:text-base">{{ getOperatorInitials() }}</span>
                </div>
            </div>

            <!-- Name and ID -->
            <div class="min-w-0 flex-1">
                <h3 class="text-base sm:text-lg font-semibold text-gray-900 truncate">
                    {{ getOperatorFullName() }}
                </h3>
                <p class="text-xs sm:text-sm text-gray-500 truncate">
                    ID: {{ operator.id }}
                </p>
                <!-- @if (operator.externalId) {
                <p class="text-xs text-gray-400 truncate">
                    External ID: {{ operator.externalId }}
                </p>
                } -->
            </div>
        </div>

        <!-- Actions Menu -->
        <div class="flex-shrink-0">
            @if (isHandset()) {
            <button mat-icon-button [matMenuTriggerFor]="mobileMenu" class="text-gray-400 hover:text-gray-600">
                <mat-icon class="text-lg">more_vert</mat-icon>
            </button>
            } @else {
            <button mat-icon-button [matMenuTriggerFor]="desktopMenu" class="text-gray-400 hover:text-gray-600">
                <mat-icon>more_horiz</mat-icon>
            </button>
            }
        </div>
    </div>

    <!-- Stats Section -->
    <div class="grid grid-cols-2 gap-4 mb-4">
        <!-- Parking Spaces -->
        <div class="bg-blue-50 rounded-lg p-3">
            <div class="flex items-center">
                <mat-icon class="text-blue-600 mr-2 text-lg">local_parking</mat-icon>
                <div>
                    <p class="text-xs text-blue-600 font-medium">Parking Spaces</p>
                    <p class="text-lg font-semibold text-blue-900">{{ getParkingSpacesCount() }}</p>
                </div>
            </div>
        </div>

        <!-- Licenses -->
        <div class="bg-green-50 rounded-lg p-3">
            <div class="flex items-center">
                <mat-icon class="text-green-600 mr-2 text-lg">badge</mat-icon>
                <div>
                    <p class="text-xs text-green-600 font-medium">Licenses</p>
                    <p class="text-lg font-semibold text-green-900">{{ getLicensesCount() }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Assigned Parking Spaces -->
    @if (operator.parkingSpaces && operator.parkingSpaces.length > 0) {
    <div class="mb-4">
        <p class="text-sm font-medium text-gray-700 mb-2">Assigned Parking Spaces</p>
        <div class="flex flex-wrap gap-1">
            @for (space of operator.parkingSpaces; track space.id; let i = $index) {
            @if (i < 3) { <mat-chip class="text-xs">
                <mat-icon matChipAvatar class="text-sm">place</mat-icon>
                {{ space.name || 'Unnamed Space' }}
                </mat-chip>
                }
                @if (i === 3 && operator.parkingSpaces!.length > 3) {
                <mat-chip class="text-xs">
                    +{{ operator.parkingSpaces!.length - 3 }} more
                </mat-chip>
                }
                }
        </div>
    </div>
    }

    <!-- Action Buttons -->
    <div class="flex flex-wrap gap-2 pt-4 border-t border-gray-100">
        <button mat-stroked-button color="primary" (click)="onViewDetails()"
            class="flex-1 sm:flex-none text-xs sm:text-sm">
            <mat-icon class="mr-1 text-sm">visibility</mat-icon>
            View Details
        </button>

        @if (!isHandset()) {
        <button mat-stroked-button (click)="onAssignParkingSpace()" class="flex-1 sm:flex-none text-xs sm:text-sm">
            <mat-icon class="mr-1 text-sm">add_location</mat-icon>
            Assign Space
        </button>

        <button mat-stroked-button (click)="onEdit()" class="flex-1 sm:flex-none text-xs sm:text-sm">
            <mat-icon class="mr-1 text-sm">edit</mat-icon>
            Edit
        </button>
        }
    </div>

    <!-- Desktop Menu -->
    <mat-menu #desktopMenu="matMenu">
        <button mat-menu-item (click)="onEdit()">
            <mat-icon>edit</mat-icon>
            <span>Edit Operator</span>
        </button>
        <button mat-menu-item (click)="onAssignParkingSpace()">
            <mat-icon>add_location</mat-icon>
            <span>Assign Parking Space</span>
        </button>
        @if (hasAssignedParkingSpaces()) {
        <button mat-menu-item (click)="onUnassignParkingSpace()">
            <mat-icon>remove_circle</mat-icon>
            <span>Unassign Parking Space</span>
        </button>
        }
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="onDelete()" class="text-red-600">
            <mat-icon>delete</mat-icon>
            <span>Delete Operator</span>
        </button>
    </mat-menu>

    <!-- Mobile Menu -->
    <mat-menu #mobileMenu="matMenu">
        <button mat-menu-item (click)="onEdit()">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
        </button>
        <button mat-menu-item (click)="onAssignParkingSpace()">
            <mat-icon>add_location</mat-icon>
            <span>Assign Space</span>
        </button>
        @if (hasAssignedParkingSpaces()) {
        <button mat-menu-item (click)="onUnassignParkingSpace()">
            <mat-icon>remove_circle</mat-icon>
            <span>Unassign Space</span>
        </button>
        }
        <button mat-menu-item (click)="onDelete()" class="text-red-600">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
        </button>
    </mat-menu>
</div>